module.exports = __webpack_public_path__ + "img/photo-album-test-03.de7f6e0c.png";